export default __webpack_public_path__ + "static/media/vehicle_not_registered_img.552f1cb7.png";